var map = {
	"./bird-flight.webp": 4527,
	"./couple.webp": 5125,
	"./ganesh.png": 8856,
	"./night-view-mask.png": 5852,
	"./night-view.webp": 6689,
	"./palace.webp": 6434
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4756;